import { applyMiddleware, compose, createStore } from 'redux'
import thunkMiddleware from 'redux-thunk'
import { composeWithDevTools } from 'redux-devtools-extension'

import monitorReducerEnhancer from './monitorReducer'
import loggerMiddleware from './logger'
import rootReducer from '../reducers'

export const configureStore = (preloadedState) => {
  const middlewares = [thunkMiddleware]
  if (process.env.NODE_ENV === 'development') middlewares.unshift(loggerMiddleware)
  const middlewareEnhancer = applyMiddleware(...middlewares)

  const enhancers = [middlewareEnhancer]
  if (process.env.NODE_ENV === 'development') enhancers.push(monitorReducerEnhancer)
  const composedEnhancers = composeWithDevTools(...enhancers)

  const store = createStore(rootReducer, preloadedState, composedEnhancers)

  return store
}